import { ChangeEvent, useEffect, useState } from 'react'
import { useFormikContext } from 'formik'

import useNumberValidations from 'src/components/shared/ui/form/fields/hooks/useNumberValidations'
import NIGView from 'src/components/views/EscritosLexnet/components/shared/components/NIG/NIGView'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { FormField } from 'src/enums/Form'

import { useEscritosFormContext } from '../SubmitForm'

function NIG(): JSX.Element {
  const [focusedInput, setFocusedInput] = useState(1)
  const { values, setFieldValue } = useFormikContext<EscritosFormValues>()
  const { validateAfterSubmit } = useEscritosFormContext()
  const { allowInteger } = useNumberValidations()

  const NIG_1 = values[FormField.NIG_1]
  const NIG_2 = values[FormField.NIG_2]
  const NIG_3 = values[FormField.NIG_3]
  const NIG_4 = values[FormField.NIG_4]
  const NIG_5 = values[FormField.NIG_5]

  function changeFocus(e: ChangeEvent<HTMLInputElement>): void {
    const { value, maxLength } = e.target
    const input = e.target
    const inputIndex = input.attributes['data-attribute'].nodeValue
    setFocusedInput(Number(inputIndex))

    if (value.length === maxLength) {
      const NIGContainer = document.querySelector('.NIG')
      const inputs = NIGContainer && NIGContainer.querySelectorAll('input')
      if (inputs && inputs.length > focusedInput) {
        inputs[focusedInput].focus()
        setFocusedInput(prev => prev + 1)
      }
    }
    allowInteger(e)
  }

  useEffect(() => {
    const NIG = `${NIG_1}${NIG_2}${NIG_3}${NIG_4}${NIG_5}`
    setFieldValue(FormField.NIG_FULL_NUMBER, NIG, validateAfterSubmit)
  }, [setFieldValue, NIG_1, NIG_2, NIG_3, NIG_4, NIG_5])

  return <NIGView changeFocus={changeFocus} />
}

export default NIG
